import type { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../../prismicio-types';

import styles from './statisticsItem.module.scss';

interface StatisticsItemProps {
  data: Simplify<Content.ChartSliceDefaultPrimaryStatisticsItem>;
  index: number;
}
export const StatisticsItem = ({ data, index }: StatisticsItemProps) => {
  return (
    <li className={`${styles.item} ${styles[`item-${index}`]}`}>
      <p className={styles.description}>{data.description}</p>
      <div className={styles.value_wrapper}>
        <span className={styles.value}>
          {data.currency}
          {data.value}
        </span>
        <div className={styles.value_description}>
          <span className={styles.plus}>+</span>
          <span>{data.unit}</span>
        </div>
      </div>
    </li>
  );
};
